import { ListViewData } from '@y42/core/list-view';
import { AbstractFeatureEntityState, AbstractFeatureUIModel, UserRelatedData } from '@y42/feature';
import { AbstractStoreModelWithChildren } from '@y42/feature/git/state';
import { getJSONSchemaURL, Y42MetadataGitModel } from '@y42/feature/json-schema';
import {
  DynamicOrchestrationConfig,
  OrchestrationSettings,
  OrchestrationType,
  RetryConfig,
  RunExecutionTimeout,
  StaticOrchestrationConfig,
} from '@y42/json-schema';
import type { OrchestrationRunStoreModel } from '../orchestration-run/orchestration-run.model';

export class OrchestrationSettingsGitModel extends OrchestrationSettings {
  constructor(model: OrchestrationStoreModel) {
    super();
    this.$schema = getJSONSchemaURL('orchestration-settings');
    this.type = model.type;
    this.enabled = model.enabled;
    this.config = model.config;
    this.cronExpression = model.cronExpression;
    this.forceSchedule = model.forceSchedule;
    this.executionTimeout = model.executionTimeout;
    this.retryConfig = model.retryConfig;
  }
  /**
   * DO NOT MODIFY ANY PROPERTIES HERE.
   * TO LEARN HOW TO MODIFY CLASSES GENERATED FROM JSON-SCHEMA
   * TAKE A LOOK AT https://y42-com.slab.com/posts/working-with-json-schemas-1hz2gcvj
   */
}

export class OrchestrationStoreModel extends Y42MetadataGitModel implements AbstractStoreModelWithChildren {
  constructor(model: OrchestrationStoreModel) {
    super(model);
    this.$name = model.$name;
    this.$path = model.$path;
    this.$level = model.$level;
    this.$children = model.$children || [];

    this.type = model.type;
    this.enabled = model.enabled;
    this.config = model.config;
    this.cronExpression = model.cronExpression;
    this.forceSchedule = model.forceSchedule;
    this.executionTimeout = model.executionTimeout;
    this.retryConfig = model.retryConfig;
  }

  $name: string;
  $path: string;
  $level: number;
  $children: Array<OrchestrationRunStoreModel['run_id']>;

  type: OrchestrationType;
  enabled: boolean;
  config: StaticOrchestrationConfig | DynamicOrchestrationConfig;
  cronExpression: string;
  forceSchedule: boolean;
  executionTimeout?: RunExecutionTimeout;
  retryConfig?: RetryConfig;
}

export type OrchestrationUIModel = AbstractFeatureUIModel & OrchestrationStoreModel & Partial<UserRelatedData>;

export type OrchestrationListViewData = ListViewData<OrchestrationUIModel>;

export type OrchestrationState = AbstractFeatureEntityState<OrchestrationStoreModel>;
